module.exports = __webpack_public_path__ + "img/logo2.0c469d49.png";